export default {
  actions: {
  },
  getters: {
  },
  mutations: {
  },
  namespaced: true,
  state: {
  }
}